export interface AttachmentDownloadUrl {
  url: string;
}
